<template>
  <div
     class="tap-winner-buttons"
    :class="{ 'tap-winner-buttons--closing': closing }"
    @animationend="handleAnimationEnd"
  >
    <v-btn
      v-for="(members, ti) in teams"
      :key="ti"
      :disabled="submitting"
      variant="outlined"
      color="primary"
      size="large"
      class="px-6 w-100"
      @click.stop="$emit('select', ti)"
    >
      {{ members.map(m => m.name).join(" & ") }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "TapWinnerButtons",
  props: {
    teams: {
      type: Array,
      required: true
    },
    submitting: {
      type: Boolean,
      default: false
    },
    closing: {
      type: Boolean,
      default: false
    }
  },
  emits: ["select", "close-end"],
  methods: {
    handleAnimationEnd (event) {
      if (event.animationName === "teamSelectorFadeOut") {
        this.$emit("close-end");
      }
    }
  }
};
</script>

<style scoped>
.tap-winner-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  animation: tapWinnerFadeIn .3s ease-in-out;
}
.tap-winner-buttons :deep(.v-btn) {
  max-height: 34px;
}
.tap-winner-buttons--closing {
  animation: tapWinnerFadeOut .3s ease-in-out forwards;
}
@keyframes tapWinnerFadeIn {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes tapWinnerFadeOut {
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(4px); }
}
</style>
